import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    IBaseController,
    Inject,
    List,
} from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { GameLogic } from '../../Logic/GameLogic';

import isMobile from 'is-mobile';
import { BonusTypeEnum } from '../../Models/Game/BonusModel';
import { UIBonusCalculatorController } from './Bonus/UIBonusCalculatorController';
import { UIBonusClockController } from './Bonus/UIBonusClockController';
import { UIBonusLogoController } from './Bonus/UIBonusLogoController';
import { UIBonusTransformController } from './Bonus/UIBonusTransformController';
import { UIBonusMoneyController } from './Bonus/UIBonusMoneyController';

export class UIButtonLeftController extends AnimationBaseController {
    $model: GameModel;

    private _controllerList: List<IBaseController> = new List<IBaseController>();

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super('UIButtonLeftController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {},
            modelEvents: {
                applyBonus: (bonusType: BonusTypeEnum, roomIndex: number) => {
                    if (bonusType === BonusTypeEnum.clock ||
                        bonusType === BonusTypeEnum.transform ||
                        bonusType === BonusTypeEnum.calculator ||
                        bonusType === BonusTypeEnum.money ||
                        bonusType === BonusTypeEnum.logo
                    ) {
                        const bonusModel = this._gameLogic.getBonusByTypeAndRoom(bonusType, roomIndex);
                        const bonusLogic = this._gameLogic.getBonusLogicByType(bonusType);

                        if (bonusModel && bonusLogic) {
                            const key = `bonus_${bonusType}_${roomIndex}`;

                            if (this._controllerList.count() < 3 && !this._controllerList.first(o => o.$model.type === bonusType)) {
                                // DIRTY HACKS
                                if (bonusType == BonusTypeEnum.logo && this._controllerList.first(o => o.$model.type === BonusTypeEnum.transform)) {
                                    return;
                                }
                                if (bonusType == BonusTypeEnum.transform && this._controllerList.first(o => o.$model.type === BonusTypeEnum.logo)) {
                                    return;
                                }

                                this._controllerList.add(this.addChildController({
                                    instanceName: `item${this._controllerList.count()}`,
                                    view: this.getViewByType(bonusType),
                                    model: bonusModel,
                                    options: {
                                        key: key,
                                        logic: bonusLogic,
                                    },
                                }, key));

                                this.reposition();
                            }
                        }
                    }
                },
            },
        };
    }

    private getViewByType(bonusType: BonusTypeEnum): any {
        switch (bonusType) {
            case BonusTypeEnum.calculator:
                return UIBonusCalculatorController;

            case BonusTypeEnum.money:
                return UIBonusMoneyController;

            case BonusTypeEnum.clock:
                return UIBonusClockController;

            case BonusTypeEnum.logo:
                return UIBonusLogoController;

            case BonusTypeEnum.transform:
                return UIBonusTransformController;
        }

        return AnimationBaseController;
    }

    private reposition(): void {
        const margin = 140;

        this._controllerList.forEach((o, i) => {
            o.y= i * margin;
        })
    }

    protected onInitialize(): void {
        this.getDisplayObjectByQuery('item0')[0].visible = false;
        this.getDisplayObjectByQuery('item1')[0].visible = false;
        this.getDisplayObjectByQuery('item2')[0].visible = false;
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = -width / scale / 2;
        this.y = height / scale / 2 + (isMobile() ? 0 : -100);
    }

    protected onUpdate(frameRate: number) {
        const copy = this._controllerList.toArray()

        for (let i = 0; i < copy.length; i++) {
            const controller = copy[i] as IBaseController;

            if (controller && !controller.visible) {
                this._controllerList.remove(controller);
                this.removeChildController(controller);
            }
        }

        this.reposition();
    }
}

